const styles = (theme) => ({
  root: {
    backgroundColor: theme.palette.divider,
  },
});

export default styles;
